<div class="row "   *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!= '00000000-0000-0000-0000-000000000000'">
    <div class="col pl-3">
        <h4 class="mb-0 font-header" style="font-weight: 700;">Transaction Logs</h4>
    </div>
</div>
<div *ngIf="global.globalAgencyId==null || global.globalAgencyId==undefined ||global.globalAgencyId== '00000000-0000-0000-0000-000000000000'">
    <div class="row mt-4 ">
        <div class="col ">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                            agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="row mb-2"
    *ngIf="global.globalAgencyId!=null && global.globalAgencyId!='' && global.globalAgencyId!=undefined &&  global.globalAgencyId!= '00000000-0000-0000-0000-000000000000'">
    <div class="col ">
        <div class="card-body  widget-body pb-0 pt-2 mb-3">
        </div>
        <div class="mb-2">
            <div class="col p-0">
                <div widget class="card border-0 box-shadow">
                   
    
                    <!-- Filters Feilds-->
                    <div class="card-body mt-2">
                        <!-- start Date & end date Filter -->
                        <div class="row mb-2">
                            <div class="col-lg-3 ">
                                <div class="row">
                                    <div class="col-lg-4  ">
                                        <label class="label-font">Start date</label><sup style="color:red; font-size: 1.35em;
                                        top: 0em;">&nbsp;*</sup>
                                    </div>
    
                                    <div class="col-lg-8 col-11 ">
                                        <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                            [selDate]="fromDate"
                                            (inputFieldChanged)="DateFormat($event,'inputchanged','FromDate')"
                                            (dateChanged)="DateFormat($event,'datechanged','FromDate')">
                                        </my-date-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3  ">
                                <div class="row">
                                    <div class="col-lg-4  ">
                                        <label class="label-font">End date</label><sup style="color:red; font-size: 1.35em;
                                        top: 0em;">&nbsp;*</sup>
                                    </div>
                                    <div class="col-lg-8 col-11 ">
                                        <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                            [selDate]="toDate"
                                            (inputFieldChanged)="DateFormat($event,'inputchanged','ToDate')"
                                            (dateChanged)="DateFormat($event,'datechanged','ToDate')">
                                        </my-date-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 ">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <span>Log Status </span>
                                    </div>
                                    <div class="col-lg-7 col-11">
                                        <select  [(ngModel)]="TransactionLogsBO.statusType"
                                            
                                           class="form-control">
                                           <option value=""></option>
                                            <option value="Success">Success</option>
                                            <option value="Failed">Failed</option>
                                      
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="row">
                                    <div class="col-lg-4  ">
                                        <label class="label-font">Payer</label>
                                    </div>
                                    <div class="col-lg-8 col-11 ">
                                        
                                        <ng-select [(ngModel)]="TransactionLogsBO.payerId" 
                   [clearable]="true" [searchable]="true" [items]="PayerList"
                  bindLabel="Value" bindValue="Key">
                </ng-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            
                            <div class="col-lg-3">
                                <div class="row">
                                    <div class="col-lg-4  ">
                                        <label class="label-font">Client</label>
                                    </div>
                                    <div class="col-lg-8 col-11 ">                                        
                                        <ng-select [(ngModel)]="TransactionLogsBO.clientId" 
                                        [clearable]="true" [searchable]="true" [items]="ClientList"
                                       bindLabel="Value" bindValue="Key">
                                     </ng-select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="row">
                                    <div class="col-lg-2">
                                        <label class="label-font">Error Code</label>
                                    </div>
                                    <div class="col-lg-9 col-11 ">
                                       
                                        <ng-select [(ngModel)]="TransactionLogsBO.errorCode" 
                                        [clearable]="true" [searchable]="true" [items]="errorList"
                                       bindLabel="message" bindValue="code">
                                     </ng-select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 mt-md-2 mt-3">
                                <div class="text-end">
                                    <button type="button" class="btn btn-sm" (click)="filterApply()">Apply
                                    </button>
                                    <button type="button" class="btn btn-sm ms-lg-5 ms-3"  (click)="ResendtoAggregator()" [disabled]="selectedEvvid?.length==0" >Resend
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div widget class="card border-0 box-shadow">
            <div class="card-body  widget-body pt-2">
                <ejs-grid #gridTransactionLogs [dataSource]='GridDataList | async' [allowResizing]='true' [pageSettings]='initialPage'
                    *ngIf="global.globalAgencyId!= '00000000-0000-0000-0000-000000000000'" [allowSorting]='true' allowPaging='true' [allowFiltering]='true'
                    (resizeStop)="onResize($event)" [filterSettings]='filterSettings'  (checkBoxChange)="checkboxunpaidchange($event)" 
                    (dataStateChange)='dataStateChange($event)' (actionBegin)="onActionComplete($event)"
                    [showColumnChooser]='true'>
                    <e-columns>
                        <e-column type='checkbox' minWidth=50 textAlign='left' 
                        [allowEditing]='true' [edit]='checkparams' [showInColumnChooser]='false'>
                      </e-column>
                        <!-- Company -->
                        <e-column field="companyName" headerText="Company" minWidth=100 type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <!-- Status -->
                        <e-column headerText="Status" uid="statusCode" textAlign="center" [allowFiltering]="false"
                            [allowSorting]='false' [showInColumnChooser]='false' minWidth="70">
                            <ng-template #template let-data>
                                <div class="btn-Check-table" *ngIf="data.errors=='Success'"><i
                                        class="fa fa-check-circle"></i></div>
                                <div class="btn-remove-table" *ngIf="data.errors == 'Failed'"><i
                                        (click)="getErrorList(data.aggregatorEvvTransactionStatusId)"
                                        class="fa fa-exclamation-circle" data-bs-target="#TransactionLogsinfo"
                                        data-bs-toggle="modal"></i></div>
                            </ng-template>
                        </e-column>
                        <!-- TransactionId -->
                        <e-column field="transactionId" headerText="TransactionId" minWidth=100 type="string">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <!-- evvTimesheetId -->
                        <e-column field="evvTimesheetId" headerText="EvvTimesheetId" minWidth=100 type="number">
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <!-- requestPayload -->
                        <e-column field="requestPayload" headerText="Request Payload" minWidth="100" textAlign='center'
                            [allowEditing]='false' type='string' [allowSorting]='false' [allowFiltering]="false">
                            <ng-template #template let-data>
                                <button class="btn btn-edit-table text-center" data-bs-toggle="modal"
                                    data-bs-target="#showRequestPayload"
                                    (click)="getRequestPayload(data.requestPayload)">View</button>&nbsp;
                            </ng-template>
                        </e-column>
                        <!-- responseContent -->
                        <e-column field="responseContent" headerText="Response Content" minWidth="100"
                            textAlign='center' [allowEditing]='false' type='string' [allowSorting]='false'
                            [allowFiltering]="false">
                            <ng-template #template let-data>
                                <button class="btn btn-edit-table text-center" data-bs-toggle="modal"
                                    data-bs-target="#showRequestContent"
                                    (click)="getRequestContent(data.responseContent)">View</button>&nbsp;
                            </ng-template>
                        </e-column>

                        <!-- Sent Time -->
                        <e-column field="sendTimeUtc" headerText="Sent Time" minWidth=100 type="datetime"
                            [allowFiltering]="false" [format]='formatOptions'>
                            <ng-template #filterTemplate let-data>
                                <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                            </ng-template>
                        </e-column>
                        <!--------------------------------table header icon---------------->
                        <e-column width="50" [showInColumnChooser]='false'>
                            <ng-template #headerTemplate let-data>
                                <div>
                                    <span id='show' (click)='showorhidecolumns()'><i class="fa fa-cog fa-lg"
                                            aria-hidden="true"> </i></span>
                                </div>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
                <div *ngIf="global.globalAgencyId != '00000000-0000-0000-0000-000000000000'" class="text-center"
                    style="color:red">
                    <p>No data available</p>
                </div>
            </div>
        </div>
    </div>
</div>


<span id="openTransactionLogsError" data-bs-toggle="modal" data-bs-target="#TransactionLogsinfo"></span>
<div class="modal hide fade modalbackgrod" id="TransactionLogsinfo" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Error Details</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-12">
                        <ejs-grid #gridErrorListLogs [dataSource]='ErrorDataList' allowTextWrap='true'
                            [textWrapSettings]='wrapSettings' [pageSettings]='ErrorinitialPage' [allowResizing]='true'>
                            <e-columns>
                                <!-- Code -->
                                <e-column field="code" headerText="Code" minWidth=100 type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                    <!-- Message -->
                                </e-column> <e-column field="message" headerText="Message" minWidth=100 type="string">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>



<span id="openRequestPayload" data-bs-toggle="modal" data-bs-target="#showRequestPayload"></span>
<div class="modal hide fade modalbackgrod" id="showRequestPayload" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Request Payload </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-12 ">
                        <textarea class="form-control" style="height: 256px;" [(ngModel)]="RequestPayload"></textarea>

                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<span id="openRequestContent" data-bs-toggle="modal" data-bs-target="#showRequestContent"></span>
<div class="modal hide fade modalbackgrod" id="showRequestContent" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Request Content </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-12 ">
                        <textarea class="form-control" style="height: 256px;" [(ngModel)]="RequestContent"></textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>